import React from 'react'

export const DownloadFile = (fileUrl: string) => {
  open(fileUrl)
}
